var _g, _text, _text2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocalApmHorizontal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 620,
    height: 200,
    viewBox: "0 0 620 200",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(90,100)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 0,
    y2: -58,
    stroke: "#1D9E75",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 50,
    y2: -32,
    stroke: "#1D9E75",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 50,
    y2: 32,
    stroke: "#1D9E75",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 58,
    stroke: "#1D9E75",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: -50,
    y2: 32,
    stroke: "#1D9E75",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0,
    y1: 0,
    x2: -50,
    y2: -32,
    stroke: "#1D9E75",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 0,
    r: 17,
    fill: "#0F6E56"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: -58,
    r: 10,
    fill: "#5DCAA5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: -32,
    r: 10,
    fill: "#5DCAA5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 32,
    r: 10,
    fill: "#D85A30"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0,
    cy: 58,
    r: 10,
    fill: "#5DCAA5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -50,
    cy: 32,
    r: 10,
    fill: "#5DCAA5"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: -50,
    cy: -32,
    r: 10,
    fill: "#5DCAA5"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 93,
    fontFamily: "Century Gothic, URW Gothic",
    fontSize: 46,
    fontWeight: 800,
    letterSpacing: 0.5,
    fill: "#1A1A1A",
    stroke: "#1A1A1A",
    strokeWidth: 1.7,
    strokeLinejoin: "round",
    paintOrder: "stroke fill"
  }, "Local APM")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 126,
    fontFamily: "Century Gothic, URW Gothic",
    fontSize: 17,
    fontWeight: 400,
    fontStyle: "italic",
    fill: "#5F5E5A"
  }, "local APMs for everyone")));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalApmHorizontal);
export default __webpack_public_path__ + "static/media/local-apm-horizontal.1803e91f462b82af27ef68c1b16ada35.svg";
export { ForwardRef as ReactComponent };